var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resubRedirect--main"},[(_vm.isLoading)?_c('b-spinner',{attrs:{"label":"Large Spinner"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }